import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import VerticalTabsElement from './VerticalTabsElement/VerticalTabsElement';
import shallowEqual from 'fbjs/lib/shallowEqual';
import {getDynamicRefById} from 'crazyEditor/core/elements/utils/elementRefUtils';
import {VERTICAL_TAB_TRANSITION_DURATION} from 'crazyEditor/core/constants/editorConstants';


// get styles of elements that have a cursor: pointer
export function getInteractiveElements(elementId) {
  const elementRef = getDynamicRefById(elementId);
  if (elementRef) {
    return elementRef.refs.tabs.getInteractiveElements();
  }
  return [];
}

export function refreshInteractiveElementsList(elementId, onComplete) {
  const elementRef = getDynamicRefById(elementId);
  if (elementRef) {
    _.delay(elementRef.refs.tabs.refreshInteractiveElementsList, VERTICAL_TAB_TRANSITION_DURATION + 50, onComplete);
  }
}

export default class MobileTabsElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    return (
      <VerticalTabsElement ref="tabs" {...this.props} />
    );
  }
}